import { z } from "zod";
import {
  App,
  routes as allRoutes,
  fullEndpoints,
} from "@songtradr-sso/shared/common";
import {
  emailSchema,
  staticText as sharedText,
} from "@songtradr-sso/shared/frontend";
import { staticText } from "../../../shared/statics/static-text";
import { Api } from "../../../shared/utils/api.utils";

// TEXT
export const text = {
  ...staticText.accountRecovery.forgotPassword,
  shared: { inputs: sharedText.inputs },
};

// STYLES

// DATA
export const forgotPassword = (data: { email: string }) => {
  return Api.post(endpoints.forgotPassword, data);
};

// TYPES
export type FormFields = z.infer<typeof schema>;

// CONSTANTS
export const routes = allRoutes[App.Core];
const endpoints = fullEndpoints[App.Core].auth;

export const schema = z.object({
  [text.shared.inputs.email.id]: emailSchema,
});

// FUNCTIONS

// ASSETS
